module.exports = __webpack_public_path__ + "img/color_negro.31724cb1.svg";